import { Practice, PracticeLocation, User } from '../types/rbac';

/** Mock locations used by practices. */
export const mockPracticeLocations: Record<string, PracticeLocation[]> = {
  p1: [
    {
      id: 'p1-l1',
      name: 'Downtown Office',
      address: '450 Market St, Suite 1200',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94111',
      phone: '(415) 555-0100',
      latitude: 37.7897,
      longitude: -122.3972,
    },
    {
      id: 'p1-l2',
      name: 'Marina Office',
      address: '2200 Chestnut St',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94123',
      phone: '(415) 555-0101',
      latitude: 37.8013,
      longitude: -122.4385,
    },
  ],
  p2: [
    {
      id: 'p2-l1',
      name: 'Main Office',
      address: '300 Frank H Ogawa Plaza',
      city: 'Oakland',
      state: 'CA',
      zipCode: '94612',
      phone: '(510) 555-0200',
      latitude: 37.8044,
      longitude: -122.2712,
    },
  ],
  p3: [
    {
      id: 'p3-l1',
      name: 'Hope & Healing Center',
      address: '100 W Broadway, Suite 400',
      city: 'San Diego',
      state: 'CA',
      zipCode: '92101',
      phone: '(619) 555-0300',
      latitude: 32.7157,
      longitude: -117.1611,
    },
  ],
  p4: [
    {
      id: 'p4-l1',
      name: 'Summit Counseling',
      address: '1600 Broadway',
      city: 'Denver',
      state: 'CO',
      zipCode: '80202',
      phone: '(303) 555-0400',
      latitude: 39.7392,
      longitude: -104.9903,
    },
  ],
  system: [
    {
      id: 'sys-l1',
      name: 'Unify HQ',
      address: '500 Terry A Francois Blvd, Suite 300',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94158',
      phone: '(415) 555-0001',
      latitude: 37.7706,
      longitude: -122.3874,
    },
    {
      id: 'sys-l2',
      name: 'East Coast Office',
      address: '200 Park Ave, 17th Floor',
      city: 'New York',
      state: 'NY',
      zipCode: '10166',
      phone: '(212) 555-0002',
      latitude: 40.7549,
      longitude: -73.9768,
    },
    {
      id: 'sys-l3',
      name: 'Remote Telehealth Hub',
      address: '1201 S Figueroa St, Suite 100',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90015',
      phone: '(213) 555-0003',
      latitude: 34.0407,
      longitude: -118.2668,
    },
  ],
};

// Mock users with realistic data matching the design
export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Admin User',
    email: 'admin@unify.health',
    role: 'unify-admin',
    practiceId: 'system',
    practiceName: 'System',
    status: 'Active',
    createdAt: '2022-01-01',
    lastActive: '2025-12-11 09:30',
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    email: 'sarah.j@mindfultherapy.com',
    role: 'practice-owner',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2022-07-04',
    lastActive: '2025-12-11 08:15',
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    email: 'emily.r@mindfultherapy.com',
    role: 'practice-admin',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2022-09-15',
    lastActive: '2025-12-10 16:45',
  },
  {
    id: '4',
    name: 'James Wilson',
    email: 'james.w@mindfultherapy.com',
    role: 'supervisor',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2023-02-10',
    lastActive: '2025-12-11 07:20',
  },
  {
    id: '5',
    name: 'Michael Chen',
    email: 'michael.c@wellnessoakland.com',
    role: 'practice-owner',
    practiceId: 'p2',
    practiceName: 'Wellness Center Oakland',
    status: 'Active',
    createdAt: '2023-01-15',
    lastActive: '2025-12-09 14:30',
  },
  {
    id: '6',
    name: 'Amanda Foster',
    email: 'amanda.f@mindfultherapy.com',
    role: 'provider',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2023-05-20',
    lastActive: '2025-12-11 09:00',
  },
  {
    id: '7',
    name: 'Brian Davis',
    email: 'brian.d@mindfultherapy.com',
    role: 'provider',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Inactive',
    createdAt: '2023-03-01',
    lastActive: '2025-11-28 11:45',
  },
  {
    id: '8',
    name: 'Lisa Thompson',
    email: 'lisa.t@wellnessoakland.com',
    role: 'practice-admin',
    practiceId: 'p2',
    practiceName: 'Wellness Center Oakland',
    status: 'Active',
    createdAt: '2023-04-12',
    lastActive: '2025-12-10 15:20',
  },
  {
    id: '9',
    name: 'David Kim',
    email: 'david.k@mindfultherapy.com',
    role: 'practice-assistant',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2023-08-05',
    lastActive: '2025-12-11 08:45',
  },
  {
    id: '10',
    name: 'Rachel Martinez',
    email: 'rachel.m@wellnessoakland.com',
    role: 'provider',
    practiceId: 'p2',
    practiceName: 'Wellness Center Oakland',
    status: 'Pending',
    createdAt: '2025-12-01',
    lastActive: '2025-12-01 10:00',
  },
  // Clients
  {
    id: 'c1',
    name: 'Alex Rivera',
    email: 'alex.rivera@email.com',
    role: 'client',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2024-06-12',
    lastActive: '2025-12-11 09:15',
  },
  {
    id: 'c2',
    name: 'Jordan Lee',
    email: 'jordan.lee@email.com',
    role: 'client',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Active',
    createdAt: '2024-08-22',
    lastActive: '2025-12-10 14:00',
  },
  {
    id: 'c3',
    name: 'Morgan Taylor',
    email: 'morgan.taylor@email.com',
    role: 'client',
    practiceId: 'p1',
    practiceName: 'Mindful Therapy Group',
    status: 'Inactive',
    createdAt: '2023-11-05',
    lastActive: '2025-09-20 11:30',
  },
  {
    id: 'c4',
    name: 'Casey Nguyen',
    email: 'casey.nguyen@email.com',
    role: 'client',
    practiceId: 'p2',
    practiceName: 'Wellness Center Oakland',
    status: 'Active',
    createdAt: '2025-01-08',
    lastActive: '2025-12-11 08:45',
  },
  {
    id: 'c5',
    name: 'Sam Williams',
    email: 'sam.williams@email.com',
    role: 'client',
    practiceId: 'p2',
    practiceName: 'Wellness Center Oakland',
    status: 'Pending',
    createdAt: '2025-12-02',
    lastActive: '2025-12-02 10:00',
  },
];

export const mockPractices: Practice[] = [
  {
    id: 'system',
    name: 'System',
    ownerId: '1',
    ownerName: 'Admin User',
    userCount: 1,
    createdAt: '2022-01-01',
    status: 'Active',
    locations: mockPracticeLocations.system,
  },
  {
    id: 'p1',
    name: 'Mindful Therapy Group',
    ownerId: '2',
    ownerName: 'Sarah Johnson',
    userCount: 24,
    createdAt: '2024-01-15',
    status: 'Active',
    locations: mockPracticeLocations.p1,
  },
  {
    id: 'p2',
    name: 'Wellness Center Oakland',
    ownerId: '5',
    ownerName: 'Michael Chen',
    userCount: 18,
    createdAt: '2024-02-20',
    status: 'Active',
    locations: mockPracticeLocations.p2,
  },
  {
    id: 'p3',
    name: 'Hope & Healing Associates',
    ownerId: 'u3',
    ownerName: 'Jennifer Martinez',
    userCount: 31,
    createdAt: '2024-03-10',
    status: 'Active',
    locations: mockPracticeLocations.p3,
  },
  {
    id: 'p4',
    name: 'Summit Counseling Services',
    ownerId: 'u4',
    ownerName: 'David Thompson',
    userCount: 12,
    createdAt: '2024-04-05',
    status: 'Inactive',
    locations: mockPracticeLocations.p4,
  },
];
